import { render } from "./trash.svg?vue&type=template&id=8b7ccf9e"
const script = {}
script.render = render

export default script